import { getApiBase } from "../apiBase";
import {
  filenameFromContentDisposition,
  projectFieldFileAuthHeaders,
  triggerBrowserDownload,
} from "../projectFieldFileAuth";
import {
  isAllDepartmentsInvolvement,
  isNetworkingAccountingOnlyDepartments,
} from "../projectPhaseDisplay";
import { normalizeDepartments } from "./commercialProjectSchema";

export function projectUsesGeneratedWorkOrderExcel(summary) {
  const involvement = normalizeDepartments(
    summary?.departments ?? summary?.department_involvement
  );
  return (
    isNetworkingAccountingOnlyDepartments(involvement) ||
    isAllDepartmentsInvolvement(involvement)
  );
}

/** @deprecated Prefer projectUsesGeneratedWorkOrderExcel */
export function projectUsesNetworkingWorkOrderExcel(summary) {
  return projectUsesGeneratedWorkOrderExcel(summary);
}

export function workOrderExcelDownloadUrl(projectId) {
  const id = Number(projectId);
  if (!Number.isFinite(id)) return "";
  return `${getApiBase()}/projects/${id}/work-order-excel`;
}

/**
 * Download a filled work-order Excel for the project (template chosen by departments).
 * @returns {Promise<boolean>}
 */
export async function downloadFilledWorkOrderExcel(projectId, { onError } = {}) {
  const url = workOrderExcelDownloadUrl(projectId);
  if (!url) {
    const msg = "Invalid project id";
    if (typeof onError === "function") onError(msg);
    else window.alert(msg);
    return false;
  }
  try {
    const res = await fetch(url, {
      headers: projectFieldFileAuthHeaders(),
      cache: "no-store",
    });
    if (!res.ok) {
      let msg = `Download failed (${res.status})`;
      try {
        const body = await res.json();
        if (body?.error) msg = String(body.error);
      } catch {
        /* ignore */
      }
      throw new Error(msg);
    }
    const blob = await res.blob();
    const filename =
      filenameFromContentDisposition(res.headers.get("Content-Disposition")) ||
      "work-order.xlsx";
    triggerBrowserDownload(blob, filename);
    return true;
  } catch (err) {
    const msg = err?.message || "Could not download work order Excel";
    if (typeof onError === "function") onError(msg);
    else window.alert(msg);
    return false;
  }
}

/** @deprecated Prefer downloadFilledWorkOrderExcel */
export async function downloadFilledNetworkingWorkOrderExcel(projectId, opts) {
  return downloadFilledWorkOrderExcel(projectId, opts);
}
